import { foundationClient } from "../client/foundation-client"
import { Country } from "./types"

export const configurationsApi = {
	getCounties: (): Promise<Country[]> =>
		foundationClient
			.get("/configurations/countries")
			.then(response => response.data),
}
